<template>
  <!-- <v-shape :config="shapeConfig" /> -->
  <canvas ref="offlineWaveformCanvas" :width="stageWidth" :height="stageHeight"></canvas>
  <v-image :config="{
    image: offlineWaveformCanvas,
  }" />
</template>

<script setup>
import { inject, onMounted, ref, watch, watchEffect } from 'vue';
import { useAudioStore } from '../../stores/AudioStore';
import { useChartRenderStore } from '../../stores/ChartRenderStore';

const mainChartRender = inject('chartRender')
const { stageWidth, stageHeight, negativeVisibleTime } = mainChartRender
const audioStore = useAudioStore()

const offlineWaveformCanvas = ref(null);
const ctx = ref(null)

const chartRenderStore = useChartRenderStore()

onMounted(() => {
  ctx.value = offlineWaveformCanvas.value.getContext("2d")
})

let isPainted = false

function drawWaveform() {
  if (isPainted) {
    ctx.value.clearRect(0, 0, stageWidth.value, stageHeight.value);
    isPainted = false
  }
  if (!ctx.value || !audioStore.waveformData || audioStore.waveformData.size <= 0 || !chartRenderStore.offlineWaveformEnabled) return;

  const halfWidth = stageWidth.value / 2;
  const startMs = Math.floor((audioStore.currentTime - negativeVisibleTime.value) * 1000);

  let baseDataZoomLevel = audioStore.waveformData.keys().next().value
  for (const key of audioStore.waveformData.keys()) {
    if (key < chartRenderStore.zoomY) break
    baseDataZoomLevel = key
  }

  const baseData = audioStore.waveformData.get(baseDataZoomLevel)

  for (let canvasPx = 0; canvasPx < stageHeight.value; canvasPx++) {
    const msStart = Math.floor(startMs + canvasPx / chartRenderStore.zoomY);
    if (msStart <= 0) continue;

    const msEnd = Math.floor(startMs + (canvasPx + 1) / chartRenderStore.zoomY);
    if (msStart >= baseData.length / baseDataZoomLevel) break;

    let min = Infinity;
    let max = -Infinity;

    for (let m = msStart * baseDataZoomLevel; m <= msEnd * baseDataZoomLevel && m < baseData.length; m++) {
      const sample = baseData[Math.trunc(m)];
      if (sample.min < min) min = sample.min;
      if (sample.max > max) max = sample.max;
    }
    const xMin = halfWidth - min * halfWidth;
    const xMax = halfWidth - max * halfWidth;

    ctx.value.beginPath();
    ctx.value.moveTo(xMin, canvasPx + 0.5,);
    ctx.value.lineTo(xMax, canvasPx + 0.5);
    ctx.value.strokeStyle = '#007bff';
    ctx.value.stroke();
  }
  isPainted = true
}

watchEffect(drawWaveform)

</script>